// extracted by mini-css-extract-plugin
export var active = "gallery-miniature-module--active--be2d9";
export var button = "gallery-miniature-module--button--53608";